<template>
    <div v-loading="loading" v-show='show' align="center" class="booking-detail notranslate">

        <el-row style="margin: 30px 0; text-align: center">
            <label class="page-label">ご予約日の変更</label>

            <p class="change-date-note">
                変更先の日時をご確認ください。 <br/>
                予約番号が変更されますので、受付の際には変更後の予約番号をお伝えください。
            </p>
        </el-row>

        <el-row class="wrapper">
            <div class="label">{{$t("bookingConfirm.detail.label.facilityName")}}</div>
            <div class="data">{{oldBooking.facilityName}}</div>
        </el-row>
        <el-row class="wrapper">
            <div class="label time">{{$t("bookingConfirm.detail.label.bookingTime")}}</div>
            <div class="data" style="white-space: normal;">
                <p style="white-space: nowrap; margin: 0">{{oldBooking.bookingDate}} {{oldBooking.timeRange}}</p>
                <div class="arrow-icon">
                    <i class="el-icon-caret-bottom"></i>
                </div>
                <p style="white-space: nowrap; margin: 0">{{newTimeRange.date}} {{newTimeRange.time}}</p>
            </div>
        </el-row>
        <el-row class="wrapper">
            <div class="label" :style="'height: ' + height + 'px'">{{$t("bookingConfirm.detail.label.slotType")}}</div>
            <div class="data">
                <p v-for="bookedSlotType in oldBooking.bookedSlotTypes" class="slot-type">
                    <span style="padding-right: 15px">{{bookedSlotType.slotType.name}}</span>{{bookedSlotType.numberBookedSlot}}{{$t("bookingConfirm.detail.personUnit")}}
                </p>
            </div>
        </el-row>
        <el-button :disabled="loading" v-show="!changeSuccess" class="change-date" @click="changeDate">
            {{$t("bookingConfirm.detail.btn.changeDate")}}
        </el-button>
        <el-button class="cancel" @click="back">{{$t("bookingConfirm.detail.btn.back")}}</el-button>

    </div>
</template>

<script>
    import BookingApi from '@/api/booking/BookingApi';
    import moment from "moment";
    import AlertService from '@/service/alert.service';
    import Pages from "@/router/Pages";

    export default {
        name: "ChangeBookingDateConfirm",
        data() {
            return {
                show: false,
                oldBooking: {},
                newTimeRange: {},
                height: 0,
                loading: false,
                bookingDate: null,
                changeSuccess: false
            }
        },
        methods: {
            back() {
                if (this.changeSuccess) {
                    this.$router.push({path: "/myPage/bookingConfirm"});
                } else {
                    this.show = false;
                    this.loading = false;
                    this.oldBooking = {};
                    this.newTimeRange = {};
                    this.$emit("back");
                }

            },
            load(oldBooking, newTimeRange) {
                this.show = true;
                this.oldBooking = oldBooking;
                this.newTimeRange = newTimeRange;
                this.height = 36 + this.oldBooking.bookedSlotTypes.length * 26;

                this.oldBooking.bookingDate = moment(this.oldBooking.bookingDate).format("YYYY/MM/DD (dd)");

                this.bookingDate = this.newTimeRange.date;
                this.newTimeRange.date = moment(this.newTimeRange.date).format("YYYY/MM/DD (dd)")
            },
            changeDate() {
                this.loading = true;
                BookingApi.changeBookingDate(this.oldBooking.code, this.newTimeRange.code, this.bookingDate)
                    .then(response => {
                        if (response.status.success) {
                            AlertService.success(this.$t("bookingConfirm.detail.message.changeBookingTimeSuccess"));
                            this.changeSuccess = true;
                            const bookingNumber = response.data.bookingNumber;
                            this.$router.push({path: "/myPage/bookingConfirm?bookingNumber=" + bookingNumber});

                        } else if (response.status.errorType == "EXCEED_LIMIT_BOOKING_SLOT") {
                            AlertService.success(this.$t("bookingConfirm.detail.message.changeBookingFail_dontHaveEnoughSlot"));
                        } else if (response.status.errorType == "UPDATE_STALE_DATA") {
                            AlertService.warning(this.$t("bookingConfirm.detail.message.updateBookingFail_editOldData"), 2000);
                            this.$router.push({path: Pages.bookingConfirm.path});
                        } else {
                            AlertService.error(this.$t("common.serverErrorMessage"), 2000);
                        }
                        this.loading = false;

                    });
            }
        },
    }
</script>

<style scoped lang="scss">
    @media screen and (max-width: 1000px) {
        .booking-detail {
            width: 100%;
        }
        .page-label {
            font-size: 30px;
            position: relative;
            display: inline-block;
            width: calc(80% - 50px);
            margin: 0 calc(10% + 25px);
        }
        .label {
            width: 40%;
        }
        .data {
            width: 60%;
            padding: 10px 10px 10px 20px;
        }
    }

    @media screen and (min-width: 1000px) {
        .booking-detail {
            width: 80%;
        }

        .cancel-message {
            position: absolute;
        }
        .page-label {
            font-size: 40px;
        }
        .label {
            width: 30%;
        }
        .data {
            width: 70%;
            padding: 10px 10px 10px 50px;
        }
    }

    .booking-detail {
        margin: auto;
        position: relative;
    }

    .page-label {
        white-space: nowrap;
        font-weight: bold;
    }

    .list {
        .btn {
            width: 100%;
            text-align: left;
            position: relative;
            border-radius: 0;
        }
    }

    .change-date {
        background-color: #4B86E8;
        color: white;
    }

    .change-date-note {
        margin-top: 35px;
        padding: 10px;
        border: 1px solid red;
        border-radius: 5px;
        font-size: 15px;
        color: red;
        text-align: left;
    }


    .wrapper {
        margin-bottom: 10px;

        .label {
            vertical-align: top;
            box-sizing: border-box;
            display: inline-block;
            text-align: left;
            background-color: #cfe2f3;
            padding: 10px;
            font-weight: bold;

            &.coupon {
                background-color: #f6b26b;
            }
        }

        .data {
            font-weight: bold;
            box-sizing: border-box;
            display: inline-block;
            text-align: left;

            .slot-type {
                margin: 0;

                &:first-child {
                    margin-top: 8px;
                }

                &:last-child {
                    margin-bottom: 8px;
                }

            }
        }
    }

    .cancel, .change-date {
        width: 70%;
        margin: 10px auto;
    }

    .default {
        color: black;
        font-weight: normal;
    }

    .time {
        height: 90px;
    }

    .arrow-icon {
        text-align: center;
        display: inline-block;
        width: 215px;
        font-size: 20px;
        margin: 5px 0
    }
</style>